import React from 'react';

export interface ServerResponseContextValue {
  status?: number;
  redirectTo?: string;
}

export const ServerResponseContext = React.createContext<ServerResponseContextValue>({});
